// extracted by mini-css-extract-plugin
module.exports = {"notes":"SyncCommonIdSettings__notes--2eAPq","innerNotes":"SyncCommonIdSettings__innerNotes--2V_r1"};